
import { Sidebar, SinglePlaylistContainer } from '../components'

export const PlayListPage = () => {
    return (
        <div className='main-container'>
            <Sidebar />
            <SinglePlaylistContainer />
        </div>
    )
}
